import * as React from 'react';
import { FC } from 'react';

import { H3, SectionBody, SectionHeader } from '@portal/common/components';
import { styled } from '@portal/common/theme';
import { RefinementFilterConfig } from '@portal/common/types';

import LimitWarnings from '../../components/LimitWarnings';
import _ from '../../locale';
import DengueScenariosFiltersControls from './DengueScenariosFiltersControls';

const StyledSectionBody = styled(SectionBody)({
    marginTop: 0,
});

type Props = {
    refinementFiltersConfig?: RefinementFilterConfig;
};

const DengueScenariosSelectDataSection: FC<Props> = ({ refinementFiltersConfig }) => (
    <StyledSectionBody>
        <SectionHeader>
            <H3>{_(`data_explorer_select_data`)}</H3>
        </SectionHeader>
        <DengueScenariosFiltersControls refinementFiltersConfig={refinementFiltersConfig} />
        <LimitWarnings />
    </StyledSectionBody>
);

export default DengueScenariosSelectDataSection;
